import React from "react";
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// Datos de ejemplo para el equipo
const teamMembers = [
  {
    id: 1,
    name: "Juan Pérez",
    role: "CEO & Fundador",
    description:
      "Líder visionario con amplia experiencia en dirección de empresas y estrategia.",
    image: "https://via.placeholder.com/300x300?text=Juan",
  },
  {
    id: 2,
    name: "María González",
    role: "Directora de Marketing",
    description:
      "Experta en marketing digital, comunicación y desarrollo de marcas.",
    image: "https://via.placeholder.com/300x300?text=María",
  },
  {
    id: 3,
    name: "Carlos Rodríguez",
    role: "Jefe de Desarrollo",
    description:
      "Innovador en tecnología, especializado en crear soluciones digitales.",
    image: "https://via.placeholder.com/300x300?text=Carlos",
  },
];

// Componente de Card estilizada con efecto hover
const StyledCard = styled(Card)(({ theme }) => ({
  maxWidth: 345,
  margin: "auto",
  transition: "transform 0.3s, box-shadow 0.3s",
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: theme.shadows[6],
  },
}));

const Team = () => {
  return (
    <Box sx={{ py: 5, px: 3, backgroundColor: "#f7f7f7" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Nuestro Equipo de Trabajo
      </Typography>
      <Typography
        variant="subtitle1"
        align="center"
        sx={{ mb: 4, color: "text.secondary" }}
      >
        Conoce a las personas que hacen posible nuestro éxito
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {teamMembers.map((member) => (
          <Grid item xs={12} sm={6} md={4} key={member.id}>
            <StyledCard>
              <CardMedia
                component="img"
                height="300"
                image={member.image}
                alt={member.name}
                sx={{ objectFit: "cover" }}
              />
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant="h6" component="div">
                  {member.name}
                </Typography>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  gutterBottom
                >
                  {member.role}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {member.description}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Team;
